export default function setupCombineFields() {
  const form = document.querySelector('form.combine-fields-on-submit');
  if (!form) return;

  // Avoid adding multiple listeners
  if (form.dataset.combineListenerAttached === 'true') return;
  form.dataset.combineListenerAttached = 'true';

  form.addEventListener('submit', function (e) {
    const fields = form.querySelectorAll('input.combine-me, textarea.combine-me, select.combine-me');
    let combinedDescription = '';

    fields.forEach(field => {

      const labelText = getFieldLabel(field, form);

      let value = '';

      if (field.type === 'checkbox') {
        value = field.checked ? field.value : '';
      } else if (field.type === 'radio') {
        if (!field.checked) return;
        value = field.value;
      } else if (field.tagName === 'SELECT') {
        if (field.multiple) {
          const selectedOptions = Array.from(field.selectedOptions).map(opt => opt.text.trim());
          value = selectedOptions.join('; ');
        } else {
          value = field.options[field.selectedIndex]?.text.trim() || '';
        }
      } else {
        value = field.value.trim();
      }

      if (value) {
        combinedDescription += `${labelText}\n${value}\n\n`;
      }
    });

    let hiddenInput = form.querySelector('input[name="description"]');
    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'description';
      form.appendChild(hiddenInput);
      hiddenInput.value = combinedDescription.trim();
    } else {
      const existingValue = hiddenInput.value.trim();
      hiddenInput.value = (existingValue + "\n\n" + combinedDescription).trim();
    }
  });
}

function getFieldLabel(field, form) {
  return (field.id && form.querySelector(`label[for="${field.id}"]`)?.textContent.trim()) ||
         field.dataset.label?.trim() ||
         field.getAttribute('aria-label')?.trim() ||
         field.closest('div')?.querySelector('label')?.textContent.trim() ||
         field.name;
}

